import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {BehaviorSubject, catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {SearchPaginatedAdxInvoiceResponse} from '../model/search-paginated-adx-invoice-response';
import {AdxInvoice} from '../model/adx-invoice';

@Injectable({
  providedIn: 'root'
})

export class AdxInvoiceGridService implements GridGetService<SearchPaginatedAdxInvoiceResponse> {
  private readonly baseUrl = 'dbov2/adx-invoice';
  private readonly http = inject(HttpClient);

  private readonly adxInvoices$ = new BehaviorSubject<AdxInvoice[]>([]);

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<SearchPaginatedAdxInvoiceResponse>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      tripId: filters?.['tripId'] ?? '',
    };

    removeEmptyParams(params);

    const response = this.http.get<GridServiceResponse<SearchPaginatedAdxInvoiceResponse>>(`${this.baseUrl}`, { params: {...params} })
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
    }));

    response.subscribe((res) => {
      const adxInvoices: AdxInvoice[] = Array.isArray(res.items) ? res.items.map((item: any) => ({ ...item })) : [];
      this.adxInvoices$.next(adxInvoices);
    });

    return response;
  }

  public getAdxInvoices() {
    return this.adxInvoices$.asObservable();
  }
}